import { redirect } from '@tanstack/react-router';

import { isDeveloperEnabled } from '@/lib/api/feature-flags.js';

/**
 * Route guard: if an admin has disabled the Developer section, redirect away from any `/developer*`
 * route (covers deep-links / bookmarks, not just the hidden nav entry). Fail-open — `isDeveloperEnabled`
 * returns true on any fetch/parse error, so a blip leaves the route accessible (real auth stays
 * server-side; this gate is cosmetic).
 */
export async function ensureDeveloperEnabled(): Promise<void> {
  if (!(await isDeveloperEnabled())) {
    throw redirect({ to: '/' });
  }
}
